export default __webpack_public_path__ + "static/media/utils_slide.a85f73ee.mp3";